export const getAlerts = state => state.alert.alerts.result;
